import { styled, Box, Button } from "@mui/material";

export const InteractiveButtonsRoot = styled(Box)(({ theme, show }) => {
  return {
    position: "relative",
    left: 0,
    top: "auto",
    bottom: "auto",
    width: "100%",
    height: "auto",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    zIndex: 100,
    overflow: "hidden",
    padding: "1rem",
    gap: "1.5rem",
    overflowY: "auto",
    background: `rgba(${theme.palette.companyColors?.blackRGB},0.85)`,
    boxShadow: "0px -5px 10px rgba(0,0,0,0.25)",
    borderRadius: theme?.borderRadius?.medium,
    backdropFilter: "blur(0.5rem)",
    [theme.breakpoints.up("lg")]: {
      padding: "1.5rem",
    },
  };
});

export const ContentBottom = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  padding: 0,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-end",
  bottom: 0,
}));

export const CategorySection = styled(Box)(({ theme }) => ({
  borderRadius: theme?.borderRadius?.medium,
  background: theme?.palette?.companyColors?.darkGrey2,
  gap: "1.5rem",
  display: "flex",
  flexDirection: "column",
}));

export const CategorySectionHeader = styled(Box)(({ theme }) => ({
  background: theme?.palette?.companyColors?.accent,
  borderRadius: "8px 8px 0 0",
  padding: "0.75rem 2rem",
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.up("lg")]: {
    padding: "1rem 2rem",
  },
}));

export const CategorySectionContent = styled(Box)(({ theme }) => ({
  padding: "0rem 2rem 3rem",
  gap: "1.5rem",
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.up("lg")]: {
    padding: "1.5rem 2rem 4rem",
  },
}));

export const OptionGrid = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "2rem",
  alignItems: "center",
}));

export const ToggleMenuBtn = styled(Box, {
  shouldForwardProp: (prop) => prop !== "show" && prop !== "isMobile",
})(({ theme, show, isMobile }) => ({
  position: "absolute",
  zIndex: 30,
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: theme?.palette?.companyColors?.accent,
  color: theme?.palette?.companyColors?.secondary,
  transition: "all 0.3s ease-in-out",
  pointerEvents: "auto",
  borderRadius: isMobile ? "4px 4px 0 0" : "0 4px 4px 0",
  // ===== DESKTOP POSITION =====
  ...(!isMobile && {
    top: 0,
    bottom: 0,
    margin: "auto",
    right: -38,
    width: 34,
    height: 56,
  }),

  // ===== MOBILE POSITION =====
  ...(isMobile && {
    top: 0,
    right: 0,
    transform: "translate(-50%, -100%)", // above menu
    width: 50,
    height: 25,
  }),

  "& svg": {
    transform: show
      ? isMobile
        ? "rotate(0deg)" // ▲ when menu is open
        : "rotate(90deg)" // desktop left arrow
      : isMobile
      ? "rotate(-180deg)" // ▼ when closed
      : "rotate(-90deg)", // desktop right arrow
    transition: "transform 0.3s ease-in-out",
  },

  [theme.breakpoints.up("lg")]: {
    ...(!isMobile && { width: 38, height: 70 }),
  },
}));

export const Divider = styled(Box)(({ theme, height }) => ({
  height: height ? height : "100%",
  position: "relative",
  width: "1px",
  display: "block",
  zIndex: 99,
  background: theme?.palette?.companyColors?.greyLight1,
}));

export const ResetCameraButton = styled(Button)(
  ({ theme, active, plainStyle, cameras }) => ({
    zIndex: 3,
    position: "relative",
    padding: 0,
    pointerEvents: active ? "none" : "initial",
    cursor: !active ? "pointer" : "initial",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    flexDirection: "column",
    margin: "0 7px 0 0",
    transition: "all 0.3s ease-in-out",
    [theme.breakpoints.up("lg")]: {
      margin: "0 5px 0 0",
    },
    "&:hover": { opacity: theme?.palette?.companyColors?.opacity50 },
  })
);
